import { Card, CardTitle, Col, Row } from 'reactstrap';
import PickerRange from '@components/input/PickerRange';

const FilterComponents = ({ picker, setPicker }) => {
  return (
    <Card body>
      <CardTitle>Filtro de búsqueda</CardTitle>

      <Row>
        <Col md="4">
          <PickerRange value={picker} onChange={setPicker} />
        </Col>
      </Row>
    </Card>
  );
};

export default FilterComponents;
